module.exports = __webpack_public_path__ + "img/2000019.9c9ba2d4.png";